import React, { useState } from 'react'

import { RowButton } from './button.styled'

interface RowButtonProps {
    price: number
    selectedPrice: number | null
    hasAssignedPrice: boolean
    onClick: () => void
}

export const CustomRowButton: React.FC<RowButtonProps> = ({ price, selectedPrice, hasAssignedPrice, onClick }) => {
    const [isHovered, setIsHovered] = useState(false)

    let label = ''

    if (hasAssignedPrice) {
        label = isHovered ? 'Ár törlése' : `${price} Ft`
    } else if (selectedPrice === price) {
        label = `Felülírás: ${price} Ft`
    }

    return (
        <RowButton
            type="button"
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isSelected={hasAssignedPrice}
        >
            {label}
        </RowButton>
    )
}
